export default {"src":"/_next/static/media/cnx.7c76c9de.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};